export default __webpack_public_path__ + "static/plugin-e5637fb4af1345dfb7d0c369d3df7b1c.mp4";